import { Injectable } from '@angular/core'
import { EditTemplateDrawerComponent, TemplateDrawerTab } from './edit-template-drawer.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable({ providedIn: 'root' })
export class EditTemplateDrawerService {
  constructor(private dialog: DialogService) {}

  public open(templateId: string, tab?: TemplateDrawerTab, isRolesEditable: boolean = true) {
    return this.dialog.openDrawer(EditTemplateDrawerComponent, {
      data: { templateId, tab, isRolesEditable },
      panelClass: ['drawer-full-80'],
    })
  }
}
